import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import omit from 'lodash/fp/omit';
import {
  getMarginBottomClass,
  marginBottomLevels,
} from '../../utils/marginBottom';
import { default as eventBus, EventBusType } from '../../utils/eventBus';

import styles from './accordion.css';

export const AccordionType = {
  LARGE: 'large',
};

class Accordion extends Component {
  static propTypes = {
    name: PropTypes.string,
    /**
     * proxied to eventBus
     */
    onOpen: PropTypes.func,
    /**
     * proxied to eventBus
     */
    onClose: PropTypes.func,
    type: PropTypes.oneOf([AccordionType.LARGE]),
    children: PropTypes.node.isRequired,
    firstItemExpanded: PropTypes.bool,
    /**
     * 0, 1, 2, 3, 4, 5, 6, 7
     */
    marginBottom: PropTypes.oneOf(marginBottomLevels),
  };

  static defaultProps = {
    marginBottom: 6,
    firstItemExpanded: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      expanded: props.firstItemExpanded ? 0 : null,
    };
  }

  handleOpen = (index) => {
    eventBus.dispatch({
      type: EventBusType.ON_OPEN,
      component: 'Accordion',
      index,
      name: this.props.name,
    });

    if (this.props.onOpen) {
      this.props.onOpen(index);
    }
  };

  handleClose = (index) => {
    eventBus.dispatch({
      type: EventBusType.ON_CLOSE,
      component: 'Accordion',
      index,
      name: this.props.name,
    });

    if (this.props.onClose) {
      this.props.onClose(index);
    }
  };

  handleToggle = (index) => {
    const prevExpanded = this.state.expanded;
    this.setState({ expanded: prevExpanded !== index ? index : null }, () => {
      const nextExpanded = this.state.expanded;

      if (nextExpanded === null) {
        this.handleClose(index);
      } else if (prevExpanded === null) {
        this.handleOpen(index);
      } else if (nextExpanded !== prevExpanded) {
        this.handleClose(prevExpanded);
        this.handleOpen(nextExpanded);
      }
    });
  };

  render() {
    const { type, children, marginBottom, ...rest } = omit(
      ['firstItemExpanded', 'onOpen', 'onClose'],
      this.props
    );
    const { expanded } = this.state;

    return (
      <div
        className={cn(styles.Accordion, getMarginBottomClass(marginBottom))}
        {...rest}
      >
        {React.Children.map(children, (child, index) =>
          React.cloneElement(child, {
            type,
            expanded: expanded === index,
            onToggle: () => {
              this.handleToggle(index);
            },
          })
        )}
      </div>
    );
  }
}

export { Accordion };

export default Accordion;
